import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarObjectBusinessContext } from '../../../api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const getCoreSonarObjectsContextSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateSonarObjectReferences([
					{
						aiGeneratedTracking: response.aiGeneratedTracking,
						context: response,
						sonarObjectId: request.sonarObjectId
					}
				])
		]
	},
	name: 'CoreSonarObjectsContext',
	receive: true,
	request: true,
	requestHandler: getSonarObjectBusinessContext
});
